import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { MessageContent, NumOfPaymentsArr } from './Constant';
import { paymentTypes, PortalStep } from './Enum';
import {
  getBankBranchesList,
  getBanksList,
  setCurrentStep,
  setUserDetails,
  PaymentMethodValidation,
  CheckSplitFileSignature,
  CreateSplitSignatureFile,
  setShowPopUp,
  setPopUpMessage,
  setSplitFile
} from './OrganizationPortalSlice';

import { cgTypeEnum } from '../../../utilities/enums/cgTypeEnum';
import PaymentCG from '../SaleBlock/PaymentCG/PaymentCG';
import SwipeBar from '../../Shared/SwipeBar/SwipeBar';
import BankAccountInfo from './BankAccountInfo';
import { validateInput, TextInputEnum } from '../../../utilities/validation/InputValidation';
import OrgFooterButtons from './OrgFooterButtons';
import { resetStore } from '../SaleBlock/PaymentCG/PaymentCGSlice';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import Image from 'app/Components/Shared/Image/image';
function UserPaymentInfo(props) {
  const [curPaymentType, setCurPaymentType] = useState(props.userDetails.payment.PType);
  const [error, setError] = useState('');
  const [isPaymentErr, setIsPaymentErr] = useState(false);
  const [numOfPayments, setNumOfPayments] = useState(props.userDetails.payment.numOfPayments ?? "");
  const [displayFileLink, setDisplayFileLink] = useState(props.splitFile.url !== "");
  const [canEditCC, setCanEditCC] = useState(props.steps.previous == PortalStep.OrderSummary);
  const [showIframe, setShowIframe] = useState(false);
  const [fileSigned, setFileSigned] = useState(false);

  const [bankInfo, setBankInfo] = useState({
    branchCode: props.Bank?.branchCode ?? "",
    bankCode: props.Bank?.bankCode ?? "",
    bankName: props.Bank?.bankDescription ?? "",
    bankAccountNo: props.Bank?.bankAccountNo ?? "",
    mail: props.Bank?.mail ?? "",
    isAutomatedBank: props.Bank?.isAutomatedBank ?? false
  });

  useEffect(() => {
    getDigitalFile();
    if (props.splitFile.url !== "") {
      setDisplayFileLink(true);
    }
    if (props.steps.previous == PortalStep.OrderSummary) {
      setDisplayFileLink(false);
      props.resetStore();//to reset Credit card
    }
  }, [props.splitFile.url]);

  const handleEventInNewTab = (event) => {
    if (event.data.type === 'ESignStatus') {
      if (event.data.status == "ok") {
        setError("");
        setShowIframe(false);
        setFileSigned(true);
        props.setSplitFile(true);
        window.removeEventListener('message', handleEventInNewTab);
      }
    }
  }
  window.addEventListener('message', handleEventInNewTab);

  const getDigitalFile = async () => {
    if (props.splitFile.url == "") {
      await props.CreateSplitSignatureFile({
        firstName: props.userDetails.firstName,
        lastName: props.userDetails.lastName,
        city: props.userDetails.address.city,
        zipCode: props.userDetails.address.zipCode,
        street: props.userDetails.address.street,
        houseNum: props.userDetails.address.houseNum,
        companyName: props.orgDetails.orgName,
        idNumber: props.userDetails.userId,
        subscriberNumber: props.userDetails.phoneNumber,
        destMail: props.userDetails.mail
      })
    }
  }

  const goToNextPage = async () => {
    var canContinue = false;
    if (curPaymentType == cgTypeEnum.DEBTPAYMENT) {
      const accountNoErr = validateAndSetError(bankInfo.bankAccountNo, TextInputEnum.bankAccountNo);
      const mailErr = bankInfo.isAutomatedBank ? validateAndSetError(bankInfo.mail, TextInputEnum.Mail) : '';
      if (accountNoErr || mailErr) {
        return canContinue;
      }
    } else if (curPaymentType == cgTypeEnum.CHECKCARD) {
      if (props._paymentCg.CGData.ccToken == "") {
        props.setPopUpMessage(MessageContent.PaymentValidationFailed)
        props.setShowPopUp(true);
        return canContinue;
      }
    }

    var paymentValidationReq = {
      idNumber: props.userDetails.userId,
      subscriberNumber: props.userDetails.phoneNumber,
      paymentType: curPaymentType,
      idType: 'I',
      accountType: 'C',
      accountSubType: '+',
      accountMidType: '*',
    };

    if (curPaymentType == cgTypeEnum.CHECKCARD) {
      paymentValidationReq = {
        ...paymentValidationReq,
        creditCardType: props._paymentCg.CGData.ccType,
        creditCardNumber: props._paymentCg.CGData.ccToken,
      }
    } else {
      paymentValidationReq = {
        ...paymentValidationReq,
        bankAccountNo: bankInfo.bankAccountNo,
        bankCode: bankInfo.bankCode,
        branchCode: bankInfo.branchCode
      }
    }

    //1434
    await props.PaymentMethodValidation({ ...paymentValidationReq }).then((res) => {
      if (res.payload.Body.isSuccess) {
        setIsPaymentErr(false);
        canContinue = true;
        props.setUserDetails({
          ...props.userDetails,
          payment: {
            PType: curPaymentType,
            CreditCard: {
              cardDueYear: props._paymentCg.form.CardDueYear,
              cardDueMonth: props._paymentCg.form.CardDueMonth,
              cvv: props._paymentCg.CGData.cvv,
              ccToken: props._paymentCg.CGData.ccToken,
              ccType: props._paymentCg.CGData.ccType,
              credit4Digits: props._paymentCg.Credit4Digits.slice(props._paymentCg.Credit4Digits.length - 4),
            },
            Bank: {
              ...bankInfo
            },
            numOfPayments: numOfPayments || "1"
          }
        });
        canContinue = true;
      }
    }).catch(() => {
      props.setShowPopUp(true);
      props.setPopUpMessage(MessageContent.PaymentValidationFailed);
      setIsPaymentErr(true);
      setCanEditCC(true);
      canContinue = false;
    });
    if (canContinue && !props.splitFile.isSigned) {
      await props.CheckSplitFileSignature(props.splitFile.guid).then((res) => {
        if (res.payload.Body.isSigned) {
          canContinue = true;
        } else {
          setError('אנא חתום על הטופס');
          canContinue = false;
        }
      });
    }
    return canContinue;
  };


  const validateAndSetError = (value, inputType) => {
    const error = validateInput(value, inputType);
    if (error !== '') {
      setError(error);
      return true;
    }
    return false;
  };

  const openSplitFile = () => {
    window.scrollTo(0, 0);
    setShowIframe(true);
  };


  return (
    <>
      {showIframe ?
        <iframe className="SplitFile" src={props.splitFile.url}></iframe>
        :
        <div className='Payment_info'>
          <div className='step-page_S'>{
            props.orgDetails.allowBankPayment &&
            <SwipeBar onChangeTab={(val) => setCurPaymentType(val)} currentTab={curPaymentType} swiperItems={paymentTypes} />
          }
            {curPaymentType == cgTypeEnum.CHECKCARD ? (
              <div>

                <div className='M_Title'> פרטי כרטיס אשראי</div>
                <div className='S_SubTitle'>מלאו את פרטי האשראי איתו תרצו לשלם</div>
                <PaymentCG
                  type={cgTypeEnum.CHECKCARD}
                  isHideTermsCheckboxg
                  padding='0'
                  showPaymentCount
                  noLoader
                  isShowIdNumber={true}
                  edit={canEditCC}
                  isPaymentErr={isPaymentErr}
                  customerId={props.userDetails.userId}
                  source="OrganizationPortalBlock"
                />
                {props.modelPrice && props.modelPrice > 0 &&
                  <div className='info_section'>
                    <div className='S_Title'> בחרו מספר תשלומים</div>
                    <div className='numOfPayments'>
                      <div className='subTitle'> סה"כ לתשלום : {props.modelPrice} ₪ </div>
                      <ReactSelect
                        getOptionLabel={(option) => option}
                        getOptionValue={(option) => option}
                        placeholder={numOfPayments || 'מספר תשלומים'}
                        value={numOfPayments}
                        name='NumOfPayments'
                        options={NumOfPaymentsArr}
                        onChange={(numOfPay) => { setNumOfPayments(numOfPay) }}
                      />
                    </div>
                  </div>
                }
              </div>
            ) : (
              <BankAccountInfo setError={setError} setBankInfo={setBankInfo} bankInfo={bankInfo} />
            )}
            {
              displayFileLink &&

              <div className='info_section'>
                <p className='S_Title'> מסמכים לחתימה </p>
                <div className='signature_file'>
                  <Image className='file_icon' src={require(fileSigned || props.splitFile.isSigned ? './icons/check.svg' : './icons/file.svg')} />
                  <div>
                    {
                      (fileSigned || props.splitFile.isSigned) ?
                        <p>המסמך נחתם בהצלחה</p> :
                        <a className='file_link' href='#' onClick={() => openSplitFile()}>
                          טופס פיצול לחתימה
                        </a>
                    }
                  </div>
                </div>

              </div>
            }
          </div>
          <OrgFooterButtons btnText={"לסיום וצפייה בפרטי ההזמנה"} onContinue={() => goToNextPage()} error={error} />
        </div>
      }
    </>
  );
}

const mapStateToProps = (state) => ({
  userDetails: state.organizationPortal.userDetails,
  steps: state.organizationPortal.steps,
  _paymentCg: state.PaymentCG,
  splitFile: state.organizationPortal.splitFile,
  orgDetails: state.organizationPortal.orgDetails,
  Bank: state.organizationPortal.userDetails.payment.Bank,
  modelPrice: state.organizationPortal.userDetails.selectedPlan.model.price
});

const mapDispatchToProps = {
  setCurrentStep,
  getBankBranchesList,
  PaymentMethodValidation,
  CheckSplitFileSignature,
  CreateSplitSignatureFile,
  getBanksList,
  setUserDetails,
  setShowPopUp,
  setPopUpMessage,
  resetStore,
  setSplitFile
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPaymentInfo);
